import { useEffect, useState } from "react";
import {ServiceUtils} from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useNavigate } from "react-router-dom";

const useStatesHook = () => {
      const navigate = useNavigate();
      const [statesList, setStatesList] = useState([]);
      const [drugClasses, setDrugClasses] = useState([]);
    useEffect(() => {
        getStates();
        getDrugClasses();
    }, [])

    const getStates = () => {
      ServiceUtils.getRequest("getMedicaidStates").then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            let res = JSON.parse(JSON.stringify(response.data?.data?.state_list));
            setStatesList(res);
          } else if (response.status === 401) {
            navigate("/logout");
          } else {
            alertService.error(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    };

    const getDrugClasses = () => {
      ServiceUtils.getRequest("getMedicaidDrugClasses").then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            let res = JSON.parse(JSON.stringify(response.data?.data?.drug_classes));
            setDrugClasses(res)
          } else if (response.status === 401) {
            navigate("/logout");
          } else {
            alertService.error(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    };

    return {statesList, drugClasses};
}

export default useStatesHook;